import { useEffect, useState } from "react";
import { UseFormClearErrors, UseFormSetError, UseFormSetValue } from "react-hook-form";
import {
    DEFAULT_CARD_IMAGE,
    formatCardNumber,
    getCardTypeByValue,
} from "../../utils/cardFormatter";
import Input from "./Input";

type InputProps = {
    title?: string;
    name?: string;
    inputClassName?: string;
    checkCvc?: string;
    cvcValue?: string;
    editing?: boolean;
    value?: string;
    children?: JSX.Element | false | undefined;
    setValue?: UseFormSetValue<any>;
    setError?: UseFormSetError<any>;
    clearErrors?: UseFormClearErrors<any>;
    hidden: boolean;
};
function CCInput({
    title,
    name = '',
    inputClassName,
    editing,
    value = '',
    children,
    checkCvc,
    cvcValue,
    setError,
    clearErrors,
    setValue,
    hidden,
}: InputProps) {
    const [uri, setUri] = useState(DEFAULT_CARD_IMAGE);
    const [hiddenValue, setHiddenValue] = useState("");
    const REGEX = /\d{4}$/;

    useEffect(() => {
        if (value) {
            const r = REGEX.exec(value)
            if (!r) return setHiddenValue("***")
            let hidden = "";
            for (let i = 0; i < value.length - 4; i++) hidden += "*";
            hidden += r[0];
            setHiddenValue(hidden)
        } else {
            setHiddenValue("");
        }
    }, [value])


    useEffect(() => {
        getCardTypeByValue(value)?.type
            ? setUri(getCardTypeByValue(value).image)
            : setUri(DEFAULT_CARD_IMAGE);
        if (
            value &&
            (!getCardTypeByValue(value)?.type ||
                (getCardTypeByValue(value)?.maxCardNumberLength &&
                    value.length != getCardTypeByValue(value)?.maxCardNumberLength))
        ) {
            setError?.(name, { type: "invalidCard", message: "Card is invalid" });
        } else {
            clearErrors?.(name);
        }
        if (cvcValue && checkCvc && cvcValue.length > getCardTypeByValue(value)?.cvcLength) {
            setError?.(checkCvc, { type: "invalidCvc", message: "Invalid cvc" });
        } else {
            clearErrors?.(checkCvc);
        }
    }, [value]);

    const handleCardChange = (val: string) => {
        setValue?.(name, formatCardNumber(val), { shouldValidate: true, shouldDirty: true });
    };
    return (
        <Input
            editing={editing}
            title={title}
            value={hidden ? hiddenValue : value}
            name={name}
            className={inputClassName}
            inputClassName={!editing ? 'bg-color15 text-color1' : ''}
            onChangeFunction={(val) => handleCardChange(val)}
            type="card"
            uri={uri}
        >
            {children && children}
        </Input>
    );
}

export default CCInput;
